import { Typography } from '@mui/material'
import './QuoteStepPlaceholder.css'

export default function QuoteStepPlaceholder({ status }: { status: string }) {
  return (
    <div className="quote-step-placeholder">
      <Typography variant="h6">{status}</Typography>
      <Typography color="text.secondary">This step is not implemented yet.</Typography>
    </div>
  )
}
